import Swiper from "swiper"
import {SwiperOptions} from "swiper/types"
import {EffectCreative, EffectFade, Keyboard, Pagination, Navigation, Autoplay} from "swiper/modules"

const heroSliders = document.querySelectorAll<HTMLElement>(".g-hero-slider")

heroSliders.forEach((slider) => {
  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, EffectCreative, EffectFade, Pagination, Navigation, Autoplay],
    autoplay: slider.dataset.autoplay
      ? {
          delay: slider.dataset.autoplaySpeed ? parseInt(slider.dataset.autoplaySpeed) : 6000,
          pauseOnMouseEnter: Boolean(slider.dataset.pauseOnHover),
        }
      : false,
    slidesPerView: 1,
    spaceBetween: 8,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: slider.closest(".s-hero-slider__slider")?.querySelector<HTMLElement>(".g-hero-slider__button.--next"),
      prevEl: slider.closest(".s-hero-slider__slider")?.querySelector<HTMLElement>(".g-hero-slider__button.--prev"),
    },
    pagination: {
      el: slider.querySelector<HTMLElement>(".g-hero-slider__pagination"),
      clickable: true,
    },
    effect: slider.dataset.effect,
    creativeEffect:
      slider.dataset.effect == "creative"
        ? {
            prev: {
              translate: [0, 0, -400],
              opacity: 0,
            },
            next: {
              translate: ["calc(100% + 8px)", 0, 0],
            },
          }
        : undefined,
    on: {
      init: () => {
        slider.classList.remove("--loading")
      },
    },
  }

  new Swiper(slider, swiperSettings)
})
